import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        companies: [],
        feed: [],
        filters: [],
        searchQuery: null,
        filterQuery: null,
        searchInputOpen: false,
        isMobile: false,
        feedSidebarOpen: false,
        filterSidebarOpen: false,
        FAQisVisible: true,
    },
    getters: {
        companiesFilterByQuery: (state) => (query) => {
            if (!query) {
                return state.companies;
            } else {
                return state.companies.filter((company) => {
                    return company.title.toLowerCase().indexOf(query.toLowerCase()) != -1;
                });
            }
        },
        companiesFilterByTags: (state) => (tags) => {
            if (!tags) {
                return state.companies;
            } else {
                return state.companies.filter((company) => {
                    const mergedTags = Object.keys(state.filters).flatMap((filterType) => {
                        return company[filterType].map((filter) => filter.id);
                    });
                    return tags.filter((x) => mergedTags.includes(x)).length;
                });
            }
        },
        companyById: (state) => (id) => state.companies.find((company) => parseInt(company.id) === parseInt(id)),
        companyActiveOffers: (state, getters) => (companyId) => {
            return getters.companyById(companyId).offers && getters.companyById(companyId).offers
                ? getters.companyById(companyId).offers.filter((offer) => !offer.closed)
                : [];
        },
        companyClosedOffers: (state, getters) => (companyId) => {
            return getters.companyById(companyId).offers && getters.companyById(companyId).offers
                ? getters.companyById(companyId).offers.filter((offer) => offer.closed)
                : [];
        },
    },
    mutations: {
        setCompanies(state, payload) {
            state.companies = payload;
        },
        setFeed(state, payload) {
            state.feed = payload;
        },
        setFilters(state, payload) {
            state.filters = payload;
        },
        setSearchQuery(state, payload) {
            state.searchQuery = payload;
        },
        setFilterQuery(state, payload) {
            state.filterQuery = payload;
        },
        setSearchInputOpen(state, payload) {
            state.searchInputOpen = payload;
        },
        setMobile(state, payload) {
            state.isMobile = payload;
        },
        setFeedSidebarState(state, payload) {
            state.feedSidebarOpen = payload;
        },
        setFilterSidebarState(state, payload) {
            state.filterSidebarOpen = payload;
        },
        setFAQstate(state, payload) {
            state.FAQisVisible = payload;
        },
    },
    actions: {},
    modules: {},
});
